import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { AuthProvider } from './components/auth/AuthContext';
export function AppRouter() {
  return <BrowserRouter data-id="element-36">
      <AuthProvider data-id="element-37">
        <Routes data-id="element-38">
          <Route path="/" element={<App data-id="element-40" />} data-id="element-39" />
        </Routes>
      </AuthProvider>
    </BrowserRouter>;
}